// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1070":"75336afb","8983":"75336afb"}[chunkId] + ".chunk.css");